module.exports = __webpack_public_path__ + "img/logo.0d1df7ac.png";